<template>
  <div style="text-align:center;margin-top:100px;">
    <el-button @click="refreshDbapi">刷新dbapi缓存</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    refreshDbapi () {
      this.$http.get('/dbapi/reload').then(response => {
        this.$message({
          type: response.data.success ? 'success' : 'error',
          message: response.data.message
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/SysTools.vue